// Shared catalog of category meta used by the vertical trapezium sidebar
// and the four "category frames" homepage section.
import { Scissors, Shirt, Layers, Sparkles, Gem, Briefcase, Crown, Wand2, Watch } from "lucide-react";

export const CATEGORY_TREE = [
  {
    key: "fabrics",
    label: "Fabrics",
    icon: Layers,
    image: "https://images.pexels.com/photos/6766360/pexels-photo-6766360.jpeg",
    hover: "https://images.unsplash.com/photo-1705493253566-1522b9015c58?crop=entropy&cs=srgb&fm=jpg",
    route: "/fabrics",
    sub: [
      { key: "cotton", label: "Cotton", route: "/fabrics?type=cotton" },
      { key: "linen", label: "Linen", route: "/fabrics?type=linen" },
      { key: "wool", label: "Wool", route: "/fabrics?type=wool" },
      { key: "silk", label: "Silk", route: "/fabrics?type=silk" },
      { key: "tweed", label: "Tweed", route: "/fabrics?type=tweed" },
      { key: "denim", label: "Denim", route: "/fabrics?type=denim" },
      { key: "herringbone", label: "Herringbone", route: "/fabrics?type=herringbone" },
      { key: "flannel", label: "Flannel", route: "/fabrics?type=flannel" },
    ],
  },
  {
    key: "bespoke",
    label: "Bespoke",
    icon: Scissors,
    image: "https://images.unsplash.com/photo-1591944489410-16ec1074a18e?crop=entropy&cs=srgb&fm=jpg",
    hover: "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?crop=entropy&cs=srgb&fm=jpg",
    route: "/bespoke",
    sub: [
      { key: "shirt", label: "Shirts", route: "/bespoke/shirt" },
      { key: "suit", label: "Suits", route: "/bespoke/suit" },
      { key: "trousers", label: "Trousers", route: "/bespoke/trousers" },
      { key: "blazer", label: "Blazers", route: "/bespoke/start?garment=blazer" },
    ],
  },
  {
    key: "accessories",
    label: "Accessories",
    icon: Watch,
    image: "https://images.pexels.com/photos/6766286/pexels-photo-6766286.jpeg",
    hover: "https://images.unsplash.com/photo-1633655442168-c6ef0ed2f984?crop=entropy&cs=srgb&fm=jpg",
    route: "/accessories",
    sub: [
      { key: "pocket-square", label: "Pocket Squares", route: "/accessories?sub=pocket-square" },
      { key: "ties", label: "Ties", route: "/accessories?sub=ties" },
      { key: "belts", label: "Belts", route: "/accessories?sub=belts" },
      { key: "cufflinks", label: "Cufflinks", route: "/accessories?sub=cufflinks" },
    ],
  },
];

export const OCCASIONS = [
  { key: "wedding", label: "Wedding", icon: Crown },
  { key: "reception", label: "Reception", icon: Sparkles },
  { key: "business", label: "Business", icon: Briefcase },
  { key: "casual", label: "Casual", icon: Shirt },
  { key: "festival", label: "Festival", icon: Gem },
];

export const TRENDING_WEAR_CATS = [
  { key: "shirts", label: "Shirts", why: "Tailored fits for everyday refinement.", image: "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?crop=entropy&cs=srgb&fm=jpg" },
  { key: "pants", label: "Pants", why: "Crisp drapes that elongate every silhouette.", image: "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?crop=entropy&cs=srgb&fm=jpg" },
  { key: "indo-western", label: "Indo Western", why: "Heritage cuts reimagined for the modern man.", image: "https://images.unsplash.com/photo-1591944489410-16ec1074a18e?crop=entropy&cs=srgb&fm=jpg" },
  { key: "ethnic", label: "Ethnic Wear", why: "Hand-finished elegance for celebrations.", image: "https://images.unsplash.com/photo-1633655442168-c6ef0ed2f984?crop=entropy&cs=srgb&fm=jpg" },
  { key: "accessories", label: "Accessories", why: "The finishing flourish to your look.", image: "https://images.pexels.com/photos/6766286/pexels-photo-6766286.jpeg" },
];

export const HERO_VIDEOS = [
  //"/videos/hero.mp4",                               // local (put file in public/videos/)
  "https://www.youtube.com/watch?v=1_tz0VTgrVg",
  // "https://videos.pexels.com/.../file.mp4",      // hosted mp4
];

export const LOOKBOOK_TILES = [
  { title: "Bosphorus Linen", route: "/lookbook", image: "https://images.unsplash.com/photo-1633655442168-c6ef0ed2f984?crop=entropy&cs=srgb&fm=jpg", span: "md:col-span-5 md:row-span-2" },
  { title: "Atelier Hours", route: "/lookbook", image: "https://images.unsplash.com/photo-1591944489410-16ec1074a18e?crop=entropy&cs=srgb&fm=jpg", span: "md:col-span-3" },
  { title: "Saddle & Tweed", route: "/lookbook", image: "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?crop=entropy&cs=srgb&fm=jpg", span: "md:col-span-4 md:row-span-2" },
  { title: "Black Tie", route: "/lookbook", image: "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?crop=entropy&cs=srgb&fm=jpg", span: "md:col-span-3" },
  { title: "Resort Edit", route: "/lookbook", image: "https://images.pexels.com/photos/6766286/pexels-photo-6766286.jpeg", span: "md:col-span-5" },
  { title: "Ivory Terrace", route: "/lookbook", image: "https://images.pexels.com/photos/6766360/pexels-photo-6766360.jpeg", span: "md:col-span-4" },
  { title: "Midnight Formal", route: "/lookbook", image: "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?crop=entropy&cs=srgb&fm=jpg", span: "md:col-span-3 md:row-span-2" },
  { title: "Desert Linen", route: "/lookbook", image: "https://images.unsplash.com/photo-1633655442168-c6ef0ed2f984?crop=entropy&cs=srgb&fm=jpg", span: "md:col-span-5" },
];

export const SEASONAL_TILES = [
  { name: "Monsoon Wedding", image: "https://images.unsplash.com/photo-1591944489410-16ec1074a18e?crop=entropy&cs=srgb&fm=jpg", hover: "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?crop=entropy&cs=srgb&fm=jpg" },
  { name: "Diwali Ethnic", image: "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?crop=entropy&cs=srgb&fm=jpg", hover: "https://images.unsplash.com/photo-1633655442168-c6ef0ed2f984?crop=entropy&cs=srgb&fm=jpg" },
  { name: "Corporate Essentials", image: "https://images.unsplash.com/photo-1591944489410-16ec1074a18e?crop=entropy&cs=srgb&fm=jpg", hover: "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?crop=entropy&cs=srgb&fm=jpg" },
  { name: "Summer Linens", image: "https://images.unsplash.com/photo-1633655442168-c6ef0ed2f984?crop=entropy&cs=srgb&fm=jpg", hover: "https://images.pexels.com/photos/6766360/pexels-photo-6766360.jpeg" },
];

export const SCROLL_BANNERS = [
  { name: "Marriage Look", image: "https://images.unsplash.com/photo-1591944489410-16ec1074a18e?crop=entropy&cs=srgb&fm=jpg", route: "/marriage-look" },
  { name: "Ceremony Whites", image: "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?crop=entropy&cs=srgb&fm=jpg", route: "/marriage-look" },
  { name: "Ivory Reception", image: "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?crop=entropy&cs=srgb&fm=jpg", route: "/marriage-look" },
];

export const TESTIMONIALS = [
  { name: "Aarav Mehta", city: "Bengaluru", quote: "My Bosphorus blazer felt sculpted to me. The fit, the drape — uncanny.", image: "https://images.unsplash.com/photo-1591944489410-16ec1074a18e?crop=entropy&cs=srgb&fm=jpg" },
  { name: "Rohan Iyer", city: "Mumbai", quote: "First bespoke suit and now I won't wear off-the-rack again.", image: "https://images.unsplash.com/photo-1507680434567-5739c80be1ac?crop=entropy&cs=srgb&fm=jpg" },
  { name: "Vikram Singh", city: "Delhi", quote: "SquireCouture delivered my wedding sherwani two weeks ahead of schedule.", image: "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?crop=entropy&cs=srgb&fm=jpg" },
];

export const FAQS = [
  { q: "How long does a bespoke suit take?", a: "Typically 18–21 days from measurement confirmation. We back-calculate from your event date." },
  { q: "Can I return a custom-tailored garment?", a: "Custom garments are non-returnable, however we offer a 7-day complimentary alteration window." },
  { q: "Do you ship outside India?", a: "Yes — international shipping is available via our concierge. Please contact our team." },
  { q: "How accurate is the pincode delivery date?", a: "ETAs are computed via our courier partner (Shiprocket). Metros: 3 days. Non-metros: 5–6 days." },
  { q: "Can I save multiple measurement profiles?", a: "Yes — profiles for self, spouse, parents, or colleagues, with body-type intelligence for fit." },
];
